import * as React from "react";
const SvgAgentDocumentationIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 40 40", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 20, r: 20, fill: "#ffd28d", style: {
  fill: "#ffd28d",
  fill: "color(display-p3 1 .8235 .5529)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#fff0d9", d: "M6.305 11.978C5.69 9.159 8.17 6.636 11 7.203l8.214 1.646a4 4 0 0 0 1.572 0L29 7.203c2.83-.567 5.31 1.956 4.694 4.775l-1.565 7.169a4 4 0 0 0 0 1.706l1.566 7.169c.615 2.819-1.866 5.343-4.695 4.775l-8.214-1.646a4 4 0 0 0-1.572 0L11 32.797c-2.83.568-5.31-1.956-4.695-4.775l1.566-7.169a4 4 0 0 0 0-1.706z", style: {
  fill: "#fff0d9",
  fill: "color(display-p3 1 .9412 .851)",
  fillOpacity: 1
} }));
export default SvgAgentDocumentationIcon;
